export const formColumn = (ctx) => {
  var arr = [
    {
      prop: 'meterType',
      name: '水表类型：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('water_meter_type'),
      disabled: true,
    },
  ];
  if (ctx.meterDetail.meterType == '1') {
    arr.push({
      prop: 'spaceName',
      name: '片区：',
      type: 'input',
      span: 12,
      placeholder: '无',
      disabled: true,
    });
  }
  arr.push({
    prop: 'meterNo',
    name: '水表编号：',
    type: 'input',
    placeholder: '无',
    span: 12,
    disabled: true,
  });
  if (ctx.meterDetail.meterType == '2') {
    arr.push({
      prop: 'unitName',
      name: '单元名称：',
      type: 'input',
      span: 12,
      placeholder: '无',
      disabled: true,
    });
  } else if (ctx.meterDetail.meterType == '3') {
    arr.push({
      prop: 'floorName',
      name: '楼层名称：',
      type: 'input',
      span: 12,
      placeholder: '无',
      disabled: true,
    });
  } else if (ctx.meterDetail.meterType == '4') {
    // arr.push({
    //   prop: 'meterReadingWarning',
    //   name: '抄表预警：',
    //   type: 'input',
    //   span: 12,
    //   placeholder: '无',
    //   disabled: true,
    // });
  }
  arr.push(
    {
      prop: 'category',
      name: '水表类别',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      disabled: true,
      options: ctx.$baseRequest.getDictListMapByType('water_meter_category'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警：',
      type: 'input',
      span: 12,
      placeholder: '无',
      disabled: true,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能水表：',
      type: 'select',
      placeholder: '无',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
      disabled: true,
    },
    {
      prop: 'auditStatus',
      name: '审核状态：',
      type: 'select',
      placeholder: '无',
      options: ctx.$baseRequest.getDictListMapByType('audit-status-02'),
      span: 12,
      disabled: true,
    },

    {
      prop: 'effectiveStatus',
      name: '生效状态：',
      type: 'select',
      placeholder: '无',
      options: ctx.$baseRequest.getDictListMapByType('meter_status'),
      span: 12,
      disabled: true,
    },
    {
      prop: 'remark',
      name: '备注：',
      type: 'input',
      placeholder: '无',
      span: 24,
      disabled: true,
    },
    {
      prop: 'createPersonName',
      name: '创建人：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    },
    {
      prop: 'gmtCreate',
      name: '创建时间：',
      type: 'input',
      placeholder: '无',
      span: 12,
      disabled: true,
    }
  );
  return arr;
};
